<template>
    <v-breadcrumbs-item>
        <router-link :to="item.to" class="d-flex align-center" style="text-decoration: none; font-size: 13px; color: var(--v-primary-base)">
            <v-icon size="13" class="mr-1">{{ item.icon }}</v-icon>
            {{ item.text }}
        </router-link>
    </v-breadcrumbs-item>
</template>


<script>
export default {
    name: 'Breadcrumb',
    props: {
        item: Object,
    },
    components: {},

    data() {
        return {};
    },

    methods: {},

    computed: {},

    watch: {},
};
</script>


<style lang='scss' scoped></style>